import { BikeFleetType } from "features/bikeFleet/types/bikeFleetType"
import { HeaderGroup } from "react-table"
import { twMerge } from "tailwind-merge"

type HeaderTableBikeFleetProps = {
	headerGroups: HeaderGroup<BikeFleetType>[]
	getColumnSize: (columnName: string) => string
}

export const HeaderTableBikeFleet : React.FC<HeaderTableBikeFleetProps> = ({
	headerGroups,
	getColumnSize,
}) => {
	return (
		<thead>
			{headerGroups.map((headerGroup) => (
				<tr className="c-table__row" {...headerGroup.getHeaderGroupProps()}>
					{headerGroup.headers.map((column: any) => (
						<th
							{...column.getHeaderProps((column as any).getSortByToggleProps())}
							className={twMerge(
								"py-5 box-border w-[100%] text-xs  px-2 relative",
								getColumnSize(column?.id),
								"inline-block"
							)}
						>
							<span>{column.render("Header")}</span>
							<span>
								{column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
							</span>
						</th>
					))}
				</tr>
			))}
		</thead>
	)
}
